export default __webpack_public_path__ + "static/ico-cloud-18accdfeeeb369e64f2d6121315f259e.svg";